import {call} from "../../../shared/SagaService";
import {get} from "../../../shared/ApiService";
import {parseTransactionForInstruction} from "./helpers/parseTransactionForInstruction";
import {getLists} from "../../Transaction/initTransaction/helper/getLists";
import {readLists} from "../../Transaction/initTransaction/helper/readLists";
import { L } from "../../List/reducer";

export function* read(matchParams, context) {
    const { id } = matchParams;

    const response = yield call(get, `/instructions/${id}`, null, context);
    const data = yield response.data;

    // Step 1: Init Instruction
    const { email = {}, ...restData } = data.instruction || {};
    const instruction = {
        ...restData,
        cc_email_addresses: email.cc_addresses,
        reply_to_email: email.reply_to_address,
        email_subject: email.subject,
        email_message: email.message,
        email_form_design_id: email.form_design_id,
        email_attach_pdf: email.attach_pdf,
    };

    // Init Transaction
    const transactionType = instruction.transaction_type;
    let transaction = instruction.data;
    transaction = parseTransactionForInstruction(transactionType, transaction);
    transaction.exchange_rate = transaction.exchange_rate || null;

    // Step 2: Read Lists for Transaction
    const lists = getLists(transactionType);

    if (transaction.contact_id) {
        yield readLists(
            [...lists, L.contact_persons], {
                [L.contact_persons]: { contact_id: transaction.contact_id },
            },
        );
    }
    else {
        yield readLists(lists);
    }

    return [instruction, transaction, 'read'];
}
